import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
import Vant from 'vant'
import 'vant/lib/index.css'
import i18n from './i18n'
import 'animate.css'
Vue.use(Vant)
Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
